import SUB_STATE from "./sub/state";

export const ACCOUNT_STATE = {
  settings: null,
  addresses: null,
  balance: {},
  paid: {},
  identifier: {},
};
export default {
  customer: {
    ...ACCOUNT_STATE,
  },
  ...SUB_STATE,
};
